<template>
  <div id="app" v-if="loggedIn">
    <section class="hero  is-small">
      <!-- Hero head: will stick at the top -->
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-brand">
              <a class="navbar-item">
                <img src="./assets/icons/logo_large.png"/>
              </a>
              <a role="button" :class="{'navbar-burger': true,'is-active': showingMenu}" aria-label="menu" aria-expanded="false" @click="toggleMenu">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </a>
            </div>
            <div id="nav-menu" :class="{'navbar-menu': true, 'is-active': showingMenu}">
              <div class="navbar-end">
                <router-link :to="{ name: link.name }" :class="{'navbar-item': true, 'is-active': link.isActive == true }" v-for="link in parentRoutes" :key="link.url">
                  {{link.name}}
                </router-link>
                <span class="navbar-item">
                  <a class="button is-light " style="font-weight:bolder;" @click="logout">
                    <span>Logout</span>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
<hr>

      <!-- Hero content: will be in the middle -->
      <div class="hero-body">
        <div class="container">
          <h1 class="title" style="text-align:center; font-family:roboto">
            {{title}}
          </h1>
          <h2 class="subtitle">
            {{subtitle}}
          </h2>
        </div>
      </div>

      <!-- Hero footer: will stick at the bottom -->
      <div class="hero-foot">
        <nav class="tabs">
          <div class="container">
            <ul v-if="parentRoute && parentRoute.children!=null && parentRoute.children.length > 0">
              <li class="is-active" v-for="child in parentRoute.children" :key="child.url"><router-link :to="{name: child.name}">{{child.name}}</router-link></li>
            </ul>
          </div>
        </nav>
      </div>
    </section>
    <router-view/>
<footer class="footer">

  <div class="content has-text-centered">
    <p>
      <strong>Murimi24/7 Admin</strong> by <a href="https://fanset.net">Fanset International</a>
    </p>
  </div>
</footer>
  </div>
</template>

<script>
import LoginModal from '@/components/Accounts/LoginModal'
import { lsClear, ls }  from  '@/helpers';
export default {
  name: 'App',
  data() {
    return {
      showingMenu: false,
    }
  },
  computed: {
    parentRoutes() {
      return this.$router.options.routes.map(parentRoute=> {
        delete parentRoute.component;
        parentRoute.isActive = false;

        if((!parentRoute.children || parentRoute.children.length == 0) && parentRoute.path == this.$route.path) {
          parentRoute.isActive = true;
          return parentRoute;
        }

        if(!parentRoute.children) return parentRoute;// if there are no children just return the parentRoute
        const childrenNames = parentRoute.children.map(child=>child.name);
        if(childrenNames.indexOf(this.$route.name)>-1) {
          parentRoute.isActive = true;
        }
        return parentRoute;
      });
    },
    parentRoute() {
      const parentRoute = this.parentRoutes.filter(parentRoute=> parentRoute.isActive == true)[0];
      if (parentRoute) {
        parentRoute.children = parentRoute && parentRoute.children ? parentRoute.children.filter(route => route.link==null) : [];
      }
      return parentRoute;
    },
    route() {
      return this.$route;
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    title() {
      return this.$route.name;
    },
    subtitle() {
      return this.$store.getters.subtitle;
    }
  },
  created() {
    if(!this.loggedIn) {
      this.$modal.open({
        parent: this,
        component: LoginModal
      })
    } else {

    }
  },
  methods: {
    logout() {
      lsClear();
      window.location = '';
    },
    toggleMenu() {
      this.showingMenu = !this.showingMenu
    }
  }
}
</script>


<style lang="scss">
* {

  font-family: "Roboto";
}

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #05a859;
$primary-invert: findColorInvert($primary);
$secondary: #000000;
$secondary-invert: findColorInvert($secondary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

$card-header-color: #222;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "secondary": ($secondary, $secondary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>



// WEBPACK FOOTER //
// src/App.vue